import { toast } from 'react-toastify';
import * as APIService from 'services/clients/api';

export const useAPI = () => {
  const triggerEvent = async (options = {}) => {
    const { payload } = await APIService.triggerEvent({ ...options });
    if (!payload) {
      toast.error('Unable to trigger event at this time.');
    } else toast.success('Event triggered successfully.');

    return payload;
  };

  return { triggerEvent };
};
